/** Compact on-demand navigation for sections within the current article. */

export function initChapterSwitcher(): void {
  const switcher = document.querySelector<HTMLElement>('[data-chapter-switcher]')
  if (!switcher) return

  const trigger = switcher.querySelector<HTMLButtonElement>('[data-chapter-trigger]')
  const panel = switcher.querySelector<HTMLElement>('[data-chapter-panel]')
  const close = switcher.querySelector<HTMLButtonElement>('[data-chapter-close]')
  if (!trigger || !panel || !close) return

  const setOpen = (open: boolean): void => {
    switcher.classList.toggle('is-open', open)
    trigger.setAttribute('aria-expanded', String(open))
    panel.setAttribute('aria-hidden', String(!open))
    document.body.classList.toggle('chapter-switcher-open', open)
    if (open) close.focus()
  }

  trigger.addEventListener('click', () => setOpen(!switcher.classList.contains('is-open')))
  close.addEventListener('click', () => {
    setOpen(false)
    trigger.focus()
  })

  panel.addEventListener('click', (event) => {
    if ((event.target as Element).closest('[data-chapter-link]')) setOpen(false)
  })

  document.addEventListener('click', (event) => {
    if (!switcher.contains(event.target as Node)) setOpen(false)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && switcher.classList.contains('is-open')) {
      setOpen(false)
      trigger.focus()
    }
  })
}
